const getFolderSelectionState = (folderId, { selectedItemsMap, getNestedChildIds }) => {
  const checked = Boolean(selectedItemsMap[folderId]);
  const hasSelectedDescendant = getNestedChildIds(folderId).some(
    (childId) => selectedItemsMap[childId]
  );

  return {
    checked,
    indeterminate: !checked && hasSelectedDescendant,
  };
};

const getFolderSelectionStateById = (items, context) =>
  items
    .filter((item) => item.data?.isFolder)
    .reduce((acc, folder) => {
      acc[folder.id] = getFolderSelectionState(folder.id, context);
      return acc;
    }, {});

export { getFolderSelectionState, getFolderSelectionStateById };
